import styles from './index.less';
import React from 'react';
import { useDispatch, useSelector } from 'umi';
import Drawer from '@/components/Drawer';
import LeadSourceSwitcher from './LeadSourceSwitcher';
import { F } from '@/utils/intl';
import { DrawerWidthProvider, useDrawerWidth } from '@/components/LeadSource/context';

const DEFAULT_DRAWER_WIDTH = 800

const AddLeadDrawerContent: React.FC = () => {

  const {drawerWidth, setDrawerWidth} = useDrawerWidth()
  const {visible} = useSelector(({leads: {addLead}}: DefaultRootState) => ({
    visible: addLead?.drawer?.visible,
  }));

  const dispatch = useDispatch();

  function toggle() {
    dispatch({
      type: 'leads/toggleAddLeadsDrawer',
    });
  }
  const handleTabChange = (tab) => {
    setDrawerWidth(tab.drawerWidth || DEFAULT_DRAWER_WIDTH)
  }
  return (
    <div className={styles.drawerContainer}>
        <Drawer
          data-testid="add-lead-drawer"
          title={<F id={'pages.leads.create_lead_quick_access'} defaultMessage={'New Customer/Project'}/>}
          open={visible}
          onOpenChange={toggle}
          destroyOnHidden
          width={drawerWidth}
          style={{zIndex: 2001}}
        >
          <LeadSourceSwitcher onTabChange={handleTabChange}/>
        </Drawer>
    </div>
  );
};
const AddLeadDrawer: React.FC = () => {
  return (
    <DrawerWidthProvider>
      <AddLeadDrawerContent />
    </DrawerWidthProvider>
  );
};

export default React.memo(AddLeadDrawer, () => true);
